/**
 * Created by rhillion on 01/07/2017.
 */
import React, {Component} from 'react'
import {firebaseDB} from './helpers/fire';

export default class PlaceList extends Component {

    state = {
        places: []
    }

    componentWillMount() {
        let places = firebaseDB.ref('places').orderByKey();
        places.once('value', snapshot => {
            var records = snapshot.val();
            if (records) {
                var places = Object.keys(records).map(key => {
                    records[key].id = key
                    return records[key];
                });
                this.setState({places: places});
            }
        })
    }

    renderPlaces() {
        return this.state.places.map(place => {
                return (
                    <div key={place.key} className="item">
                        <a href={'/places/edit/' + place.key}>
                            <div className="right floated content">
                                <div className="ui button mini">Edit</div>
                            </div>
                        </a>
                        <div className="content">
                            <div className="header">
                                <a target="_blank" href={'http://www.google.com/maps/place/' + place.lat + ',' + place.lng }>{place.text}</a>
                            </div>
                        </div>
                    </div>
                )
            }
        );
    }

    render() {
        return (
            <div className="ui middle aligned selection list">
                {this.renderPlaces()}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/PlaceList.js